import { api } from "@api/api";
import { AudioFile } from "@modules/audioFiles/types";
import { AudioFileFormValues } from "@modules/audioFiles/validations";

export async function createAudioFileService(data: AudioFileFormValues): Promise<AudioFile> {
  const { file, ...body } = data;

  const { data: audioFile } = await api.post<AudioFile>("v1/audiobook_admin/", body);

  if (file && file instanceof File) {
    const formData = new FormData();
    formData.append("file", file);

    await api.patch(`v1/audiobook_admin/${audioFile.id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return audioFile;
}
